// @generated by protoc-gen-connect-query v2.0.0 with parameter "import_extension=js"
// @generated from file services/management/api/user_bookmark.proto (package gx.management.api, syntax proto3)
/* eslint-disable */

import { UserBookmarkService } from "./user_bookmark_pb.js";

/**
 * @generated from rpc gx.management.api.UserBookmarkService.ListUserBookmarks
 */
export const listUserBookmarks = UserBookmarkService.method.listUserBookmarks;

/**
 * @generated from rpc gx.management.api.UserBookmarkService.GetUserBookmarkByExternalId
 */
export const getUserBookmarkByExternalId = UserBookmarkService.method.getUserBookmarkByExternalId;

/**
 * @generated from rpc gx.management.api.UserBookmarkService.CreateUserBookmark
 */
export const createUserBookmark = UserBookmarkService.method.createUserBookmark;

/**
 * @generated from rpc gx.management.api.UserBookmarkService.DeleteUserBookmark
 */
export const deleteUserBookmark = UserBookmarkService.method.deleteUserBookmark;

/**
 * @generated from rpc gx.management.api.UserBookmarkService.DeleteUserBookmarkByExternalId
 */
export const deleteUserBookmarkByExternalId = UserBookmarkService.method.deleteUserBookmarkByExternalId;
